export const REQUEST_OTP_NS = "RequestOtp";

export const i18n = {
  en: {
    button: {
      requestOtp: "Request One Time Password",
      guest: "Access ADP",
    },
    requestForm: {
      title: "Request One Time Password",
      subtitle: "a new One Time Password will be sent to the following email",
    },
    otpForm: {
      title: "Please check your email to continue",
      subtitle: "A new One Time Password was successfully sent to",
      otpInput: {
        footerMessage:
          "Please enter the One Time Password that has been sent to your email.",
      },
      footer: {
        text: "If you can't connect to the internet, you can still log in without a One Time Password, but it may affect future identification.",
        button: "Login without one-time password",
      },
    },
    dropFileForm: {
      headerText:
        "To login without a One Time Password you need to provide the following data:",
      uploadFile: {
        title: "Upload your personal identification document",
        subtitle:
          "This can include documents such as a passport or national ID card. This is a security measure to verify your identity and ensure the safety of your account.",
        dropFile: "Drag and drop files here or click to select files",
        replace: "Replace file",
      },
      tempPassword: {
        title: "Temporary Password",
        subtitle: "Please contact the barge crew for a Temporary Password",
      },
    },
  },
};
